import styled from 'styled-components'

const EmailIntegrations = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`

export default EmailIntegrations